import quickFetch from 'quick-fetch';
import { buildEarlyRequestKey, formatPinotStatsDate, shouldEarlyRequestPinotStats, getSearchParams, getPinotStatsFiltersFromDetailsResponse } from './utils';
import { HUA_KEYS, POST_SEND_STATS_COUNTERS_TO_FETCH, POST_SEND_STATS_RATES_TO_FETCH } from './const';
import { earlyRequestHubUserAttributes } from 'frontend-preferences-client/quickFetch';
import { makeChirpEarlyRequest } from 'rpc-client-utils';
import { getStatsForInitialLoadEarlyRequestRpc } from 'ContentEmailUI/__generated__/chirp/com/hubspot/marketing/email/reports/rpc/postsend/earlyRequest/PostSendStatsRpc.early';
const DETAILS_VALID_URL = /^\/email\/([0-9]+)\/details\/([0-9]+)[/]?(?:performance|recipients|localtime)?[/]?([a-z-]+)?$/;
const STATISTICS_TIMEOUT = 30000;
function earlyRequestFetch(endpoint, responseKey, queryData, whenFinished, timeout = STATISTICS_TIMEOUT) {
  quickFetch.makeEarlyRequest(responseKey, {
    url: quickFetch.getApiUrl(endpoint, true) + queryData,
    timeout,
    dataType: 'json',
    contentType: 'application/json',
    type: 'GET',
    whenFinished
  });
}
function earlyRequestPost(endpoint, responseKey, data) {
  quickFetch.makeEarlyRequest(responseKey, {
    url: quickFetch.getApiUrl(endpoint, true),
    timeout: STATISTICS_TIMEOUT,
    data: JSON.stringify(data),
    dataType: 'json',
    contentType: 'application/json',
    type: 'POST'
  });
}
earlyRequestHubUserAttributes(HUA_KEYS, 'hua-early-request');
const url = window.location.pathname;
const {
  emailPublishDate,
  params
} = getSearchParams(window.location.search);
const detailsUrlMatch = url.match(DETAILS_VALID_URL);
if (detailsUrlMatch && params === '') {
  earlyRequestFetch('/reports/v1/settings', 'PortalBotFilterStatus', '');
  if (detailsUrlMatch.length > 1) {
    const emailId = detailsUrlMatch[2];
    earlyRequestFetch(`/cosemail-stats/v1/details/${emailId}`, `EmailDetails::${emailId}`, '', response => fetchPinotStatsCallback(response));
    earlyRequestFetch(`/cosemail-stats/v1/details/${emailId}/minimal-performance`, `PerformanceStats::${emailId}`, '');
    earlyRequestPost(`/email/marketing/reports/v1/post-send/stats/initial-load`, `MersInitialLoad::${emailId}`, {
      contentId: Number(emailId),
      counters: POST_SEND_STATS_COUNTERS_TO_FETCH,
      rates: POST_SEND_STATS_RATES_TO_FETCH
    });
    makeChirpEarlyRequest(getStatsForInitialLoadEarlyRequestRpc, {
      request: {
        contentId: Number(emailId),
        counters: POST_SEND_STATS_COUNTERS_TO_FETCH,
        rates: POST_SEND_STATS_RATES_TO_FETCH
      }
    });
    if (shouldEarlyRequestPinotStats(emailPublishDate)) {
      const data = {
        startDate: formatPinotStatsDate(Number(emailPublishDate)),
        endDate: formatPinotStatsDate(Date.now()),
        campaignIdentifier: {
          contentId: Number(emailId)
        },
        filters: {
          listInclusionIds: []
        }
      };
      earlyRequestPost('/email/alycs/v1/reports/marketing-email-performance', `PinotStats::${buildEarlyRequestKey(data)}`, data);
    }
  }
}
function fetchPinotStatsCallback(response) {
  if (emailPublishDate || !(response !== null && response !== void 0 && response.primaryEmail) || !(response !== null && response !== void 0 && response.primaryEmailId)) {
    return;
  }
  const data = getPinotStatsFiltersFromDetailsResponse(response);
  if (data) {
    earlyRequestPost('/email/alycs/v1/reports/marketing-email-performance', `PinotStats::${buildEarlyRequestKey(data)}`, data);
  }
}